import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useTranslation } from '../../src/i18n';
import { colors, fontSize } from '../../constants/styleConstants';
import MaskIcon from '../Icons/MaskIcon';
import { TP } from '../../constants/consts';
import CustomTooltip from '../CustomTooltip';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 10,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginTop: 10,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontStyle: 'italic',
    fontSize: '12px',
    marginRight: 10,
    width: '20px',
    height: '20px',
    '& > svg': {
      width: '20px',
      height: '20px',
    },
  },
  text: {
    fontSize: '12px',
    color: colors.grey3,
  },
  tooltip: {
    display: 'flex',
    fontSize: fontSize.basic,
    color: colors.blueChip,
    marginLeft: '2px',
  },
}));

export const iconsMap = {
  premier: <StarIcon style={{ color: colors.primary }} />,
  today: <RadioButtonUncheckedIcon style={{ color: colors.blueLight }} />,
  soldout: <RadioButtonUncheckedIcon style={{ color: colors.primary }} />,
  cancelledDate: <FiberManualRecordIcon style={{ color: colors.purple }} />,
  matinee: 'm',
  concert: 'c',
  tour: 't',
  maskRed: <MaskIcon isRed />,
  maskGrey: <MaskIcon />,
  performing: <div style={{ borderBottom: `2px solid ${colors.orange}` }}>12</div>,
};

export const legendItemsDefault = {
  premier: { iconType: iconsMap.premier, text: `${TP}.m_WORLDPREMIERE` },
  today: { iconType: iconsMap.today, text: `${TP}.m_TODAY` },
  soldout: { iconType: iconsMap.soldout, text: `${TP}.PERFORMANCE_SOLDOUT` },
  cancelledDate: { iconType: iconsMap.cancelledDate, text: `${TP}.PERFORMANCE_CANCELLED` },
  matinee: { iconType: iconsMap.matinee, text: `${TP}.m_MATINEE` },
  concert: { iconType: iconsMap.concert, text: `${TP}.FN_PERFORMACE_TYPE_CONCERT` },
  tour: { iconType: iconsMap.tour, text: `${TP}.m_TOURDATES` },
  maskRed: { iconType: iconsMap.maskRed, text: `${TP}.m_FROMHOUSE` },
  maskGrey: { iconType: iconsMap.maskGrey, text: `${TP}.m_FROMAGENT` },
  performing: { iconType: iconsMap.performing, text: `${TP}.m_ARTIST_PERFORMING` },
};

const Legend = ({ legendItems, title }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      {title}
      <CustomTooltip
        content={
          <div className={classes.wrapper}>
            {legendItems.map((legendItem, index) => (
              <div key={index} className={classes.item}>
                <span className={classes.icon}>{legendItem.iconType}</span>
                <span className={classes.text}>{t(legendItem.text)}</span>
              </div>
            ))}
          </div>
        }
        icon={<HelpOutlineIcon className={classes.tooltip} />}
      />
    </div>
  );
};

Legend.propTypes = {
  legendItems: PropTypes.arrayOf(
    PropTypes.shape({
      iconType: PropTypes.node,
      text: PropTypes.string,
    }),
  ),
  title: PropTypes.node.isRequired,
};

Legend.defaultProps = {
  legendItems: [
    legendItemsDefault.performing,
    legendItemsDefault.maskRed,
    legendItemsDefault.maskGrey,
    legendItemsDefault.matinee,
    legendItemsDefault.tour,
    legendItemsDefault.concert,
  ],
};

export default Legend;
